// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-list {
  height: 100%;
}
.chat-list .chat-list-card {
  height: 100%;
}
.chat-list .chat-list-card ::ng-deep .ant-card-body {
  height: calc(100% - 55px);
  overflow-y: auto;
  padding: 12px;
}
.chat-list ::ng-deep .ant-collapse {
  margin-bottom: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}
.chat-list ::ng-deep .ant-collapse.completed-job {
  opacity: 0.8;
}
.chat-list ::ng-deep .ant-collapse .ant-collapse-header {
  padding: 12px 16px !important;
}
.chat-list .job-header {
  display: flex;
  align-items: center;
  gap: 8px;
}
.chat-list .job-extras {
  display: flex;
  align-items: center;
  gap: 8px;
}
.chat-list .job-extras .job-badge {
  margin-right: 8px;
}
.chat-list .vendor-item-card {
  margin: 8px 0;
  cursor: pointer;
  transition: all 0.3s;
}
.chat-list .vendor-item-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
}
.chat-list .vendor-item-card.active-channel {
  background: #e6f7ff;
  border-color: #91d5ff;
}
.chat-list .vendor-item-card.archived {
  background: #f5f5f5;
  border-color: #e8e8e8;
  opacity: 0.65;
  cursor: not-allowed;
}
.chat-list .vendor-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.chat-list .vendor-item .vendor-item-avatar {
  flex-shrink: 0;
}
.chat-list .vendor-item .vendor-item-content {
  flex: 1;
  min-width: 0;
}
.chat-list .vendor-item .vendor-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}
.chat-list .vendor-item .vendor-item-header h6 {
  margin: 0;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-list .vendor-item .vendor-item-header .vendor-item-indicators {
  display: flex;
  align-items: center;
  gap: 8px;
}
.chat-list .vendor-item .vendor-item-message {
  color: #8c8c8c;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/main/chat/attender-chat-group-list/attender-chat-group-list.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,YAAA;AACJ;AACI;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;AACN;AAGE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AADJ;AAGI;EACE,YAAA;AADN;AAII;EACE,6BAAA;AAFN;AAME;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AALJ;AAOI;EACE,iBAAA;AALN;AASE;EACE,aAAA;EACA,eAAA;EACA,oBAAA;AAPJ;AASI;EACE,yCAAA;AAPN;AAUI;EACE,mBAAA;EACA,qBAAA;AARN;AAWI;EACE,mBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AATN;AAaE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAXJ;AAaI;EACE,cAAA;AAXN;AAcI;EACE,OAAA;EACA,YAAA;AAZN;AAeI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAbN;AAeM;EACE,SAAA;EACA,OAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAbR;AAgBM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAdR;AAkBI;EACE,cAAA;EACA,eAAA;AAhBN","sourcesContent":[".chat-list {\n  height: 100%;\n\n  .chat-list-card {\n    height: 100%;\n\n    ::ng-deep .ant-card-body {\n      height: calc(100% - 55px);\n      overflow-y: auto;\n      padding: 12px;\n    }\n  }\n\n  ::ng-deep .ant-collapse {\n    margin-bottom: 16px;\n    border: 1px solid #f0f0f0;\n    border-radius: 4px;\n\n    &.completed-job {\n      opacity: 0.8;\n    }\n\n    .ant-collapse-header {\n      padding: 12px 16px !important;\n    }\n  }\n\n  .job-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .job-extras {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    .job-badge {\n      margin-right: 8px;\n    }\n  }\n\n  .vendor-item-card {\n    margin: 8px 0;\n    cursor: pointer;\n    transition: all 0.3s;\n\n    &:hover {\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);\n    }\n\n    &.active-channel {\n      background: #e6f7ff;\n      border-color: #91d5ff;\n    }\n\n    &.archived {\n      background: #f5f5f5;\n      border-color: #e8e8e8;\n      opacity: 0.65;\n      cursor: not-allowed;\n    }\n  }\n\n  .vendor-item {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n\n    .vendor-item-avatar {\n      flex-shrink: 0;\n    }\n\n    .vendor-item-content {\n      flex: 1;\n      min-width: 0;\n    }\n\n    .vendor-item-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 4px;\n\n      h6 {\n        margin: 0;\n        flex: 1;\n        min-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .vendor-item-indicators {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n      }\n    }\n\n    .vendor-item-message {\n      color: #8c8c8c;\n      font-size: 12px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
